export default {
  badInput: 'This value seems to be invalid.',
  customError: 'This value seems to be invalid.',
  patternMismatch: 'This value seems to be invalid.',
  rangeOverflow: 'This value should be lower than or equal to %s.',
  rangeUnderflow: 'This value should be greater than or equal to %s.',
  stepMismatch: 'This value does not match the steps.',
  tooLong: 'This value is too long. It should have %s characters or fewer.',
  tooShort: 'This value is too short. It should have %s characters or more.',
  typeMismatch: 'This value seems to be invalid.',
  valueMissing: 'This value is required',
};
